import { useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom"
import getCookie from "./utils/getCookie";
import toast from "react-hot-toast";
import axios from "axios";

function Layout() {

  const handleFullscreen = (id: string) => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
      toast.dismiss(id)
    }
  }

  const handleToasts = useCallback(() => {
    const userVisitedFirstTime = getCookie("userVisitedFirstTime");
    if (!userVisitedFirstTime) {
      toast((t) => (
        <div className="flex space-x-2">
          <span>👀</span>
          <div>
            <p className="font-semibold">Switch to full screen for a better experience</p>
            <div className="flex pt-2 space-x-2">
              <button onClick={() => handleFullscreen(t.id)} className="bg-zinc-200 hover:bg-zinc-400 text-zinc-900 transition px-3 py-1.5 rounded-md">Switch Now</button>
              <button onClick={() => toast.dismiss(t.id)} className="bg-zinc-800 hover:bg-zinc-700 text-zinc-200 transition px-3 py-1.5 rounded-md">Cancel</button>
            </div>
          </div>
        </div>
      ), { duration: 8000, style: { borderRadius: "0.5rem" } });
    }

    setTimeout(() => toast("🎉 You've been here for over 100 seconds!", { duration: 4000 }), 100000);
  }, []);

  const checkHeartbeat = async () => {
    try {
      await axios.get(`${import.meta.env.VITE_WEBSOCKET_SERVER_URI}/heartbeat`);
    } catch (error) {
      console.error("Error checking heartbeat:", error);
    }
  }

  useEffect(() => {
    checkHeartbeat();
    handleToasts();
    setCookie();
  }, [handleToasts])

  return (
    <>
      <Outlet />
    </>
  )
}

export default Layout

const setCookie = () => {
  setTimeout(() => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7)
    document.cookie = `userVisitedFirstTime=true; expires=${expirationDate.toUTCString()}; path=/`;
  }, 10000);
}